import React, { useState, useRef } from "react";
import { Headphones, Loader2, Pause } from "lucide-react";
import { API_URL } from "../config";

export default function ArticleAudioButton({ postId }) {
  const [state, setState] = useState("idle"); // idle | loading | ready | playing | error
  const [error, setError] = useState("");
  const audioRef = useRef(null);

  const load = async () => {
    setState("loading");
    setError("");
    try {
      const r = await fetch(`${API_URL}/posts/${postId}/audio`);
      if (!r.ok) {
        const data = await r.json().catch(() => ({}));
        throw new Error(data.detail || "Не удалось озвучить статью");
      }
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      if (audioRef.current) {
        audioRef.current.src = url;
        await audioRef.current.play();
      }
      setState("playing");
    } catch (e) {
      setError(e.message || "Озвучка временно недоступна");
      setState("error");
    }
  };

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (audioRef.current.paused) {
      audioRef.current.play();
      setState("playing");
    } else {
      audioRef.current.pause();
      setState("ready");
    }
  };

  const onClick = () => {
    if (state === "idle" || state === "error") { load(); return; }
    togglePlay();
  };

  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <button
        onClick={onClick}
        disabled={state === "loading"}
        title="Слушать статью"
        style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "#f0f2f8", color: "#555",
          border: "none", borderRadius: 8, padding: "6px 14px", fontSize: "0.9rem",
          fontWeight: 600, cursor: state === "loading" ? "default" : "pointer",
        }}
      >
        {state === "loading" && <Loader2 size={15} strokeWidth={2.2} className="spin" />}
        {state !== "loading" && state !== "playing" && <Headphones size={15} strokeWidth={2.2} />}
        {state === "playing" && <Pause size={15} strokeWidth={2.2} />}
        {state === "loading" ? "Озвучиваем…" : state === "playing" ? "Пауза" : "Слушать"}
      </button>
      {error && <span style={{ fontSize: "0.8rem", color: "#c0392b" }}>{error}</span>}
      <audio
        ref={audioRef}
        onEnded={() => setState("ready")}
        style={{ display: "none" }}
      />
    </div>
  );
}
